<template>
  <div class="block">
    <kst-output field="Name" :data="details" :catalog="Catalog"/>
    <kst-output field="Address" :data="details" :catalog="Catalog"/>
    <kst-output field="PIC" :data="details" :catalog="Catalog"/>
    <kst-output field="NoPIC" :data="details" :catalog="Catalog"/>
    <kst-output field="IsActive" :data="details" :catalog="Catalog"/>
    <kst-output field="Comment" :data="details" :catalog="Catalog"/>
    <kst-created :data="details"/>
    <kst-last-updated :data="details"/>
  </div>
</template>

<script>
import Catalog from "../WhsCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>